// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-native-live-markdown-input-multiline {
  white-space: pre-wrap;
}

.react-native-live-markdown-input-singleline p {
  display: inline-block;
}

.react-native-live-markdown-input-multiline p {
  display: block;
}

.react-native-live-markdown-input-singleline::-webkit-scrollbar {
  display: none;
}

.react-native-live-markdown-input-singleline br {
  display: none;
}

.react-native-live-markdown-input-singleline span[data-type="text"] {
  vertical-align: middle;
}

.react-native-live-markdown-input-singleline:empty::before,
.react-native-live-markdown-input-multiline:empty::before {
  pointer-events: none;
  display: block; /* For Firefox */
  content: attr(placeholder);
}

@keyframes react-native-live-markdown-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.react-native-live-markdown-input-multiline [contenteditable='false'] {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@expensify/react-native-live-markdown/lib/module/web/MarkdownTextInput.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,oBAAoB;EACpB,cAAc,EAAE,gBAAgB;EAChC,0BAA0B;AAC5B;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB","sourcesContent":[".react-native-live-markdown-input-multiline {\n  white-space: pre-wrap;\n}\n\n.react-native-live-markdown-input-singleline p {\n  display: inline-block;\n}\n\n.react-native-live-markdown-input-multiline p {\n  display: block;\n}\n\n.react-native-live-markdown-input-singleline::-webkit-scrollbar {\n  display: none;\n}\n\n.react-native-live-markdown-input-singleline br {\n  display: none;\n}\n\n.react-native-live-markdown-input-singleline span[data-type=\"text\"] {\n  vertical-align: middle;\n}\n\n.react-native-live-markdown-input-singleline:empty::before,\n.react-native-live-markdown-input-multiline:empty::before {\n  pointer-events: none;\n  display: block; /* For Firefox */\n  content: attr(placeholder);\n}\n\n@keyframes react-native-live-markdown-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.react-native-live-markdown-input-multiline [contenteditable='false'] {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
